import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {ACTION_TYPES} from '../../../app.types';
import {notify} from '../../../notification/notfication.actions';
import {AppStore} from '../../../store/store';
import {HttpClientUtils} from '../../../utils/http-client.utils';
import {HttpInteraction} from '../../../utils/http-interactions.utils';
import {SegmentValidationActions} from './validation.actions';
import {SegmentValidationModel} from './validation.model';

@Injectable()
export class SegmentValidationService {
  private segmentValidationPath = `${environment.apiSegments}/validations/segment`;

  constructor(public appStore: AppStore, private httpClient: HttpClientUtils) {
  }

  /** NO BFF */
  getValidationList(segmentId: number) {
    this.httpClient.getForJson(`${this.segmentValidationPath}/${segmentId}`)
      .onSuccess((response: any) => {
        const segmentValidationList = SegmentValidationModel.fromList(response.data || response);
        SegmentValidationActions.dispatchValidationListForSegment(segmentValidationList, this.appStore);
      })
      .onError((error) => {
        SegmentValidationActions.dispatchValidationError(this.appStore, HttpInteraction.errorModel(error));
      })
      .doIt();
  }

  /** NO BFF */
  createValidation(segmentId: number, segmentValidationModel: SegmentValidationModel) {
    const validationToPost = {
      validationSegmentId: segmentId,
      name: segmentValidationModel.name,
      positiveExampleId: segmentValidationModel.positiveExample.id,
      totalPopulationId: segmentValidationModel.totalPopulation.id
    };

    this.httpClient.post(`${environment.apiSegments}/validations`, validationToPost)
      .onSuccess((response: any) => {
        segmentValidationModel.id = response.data ? response.data.id : response.id;
        SegmentValidationActions.dispatchCreatedValidation(segmentValidationModel, this.appStore);
        notify(this.appStore, 'Validation created');
      })
      .onError((error) => {
        SegmentValidationActions.dispatchValidationError(this.appStore, HttpInteraction.errorModel(error));
      })
      .doIt();
  }

  deleteValidation(validationId: number) {
    this.httpClient.delete(`${environment.apiSegments}/validations/${validationId}`)
      .onSuccess(() => {
        SegmentValidationActions.dispatchSuccessDelete(this.appStore, validationId);
        notify(this.appStore, 'Validation deleted!');
      })
      .onError((error) => {
        SegmentValidationActions.dispatchDeleteError(this.appStore, HttpInteraction.errorModel(error));
      })
      .doIt();
  }

  initDialog() {
    SegmentValidationActions.dispatchInitDialog(this.appStore);
  }

  select(validation: SegmentValidationModel) {
    this.appStore.dispatch({type: ACTION_TYPES.SEGMENT_VALIDATION_SELECTED, segmentValidation: validation});
  }

  updateValidation(validation: SegmentValidationModel) {
    const validationPut = {
      id: validation.id,
      name: validation.name,
      positiveExampleId: validation.positiveExample.id,
      totalPopulationId: validation.totalPopulation.id
    };

    this.httpClient.put(`${environment.apiSegments}/validations`, validationPut)
      .onSuccess(() => {
        SegmentValidationActions.dispatchUpdateSuccess(validation, this.appStore);
        notify(this.appStore, 'Validation updated');
      })
      .onError((error) => {
        SegmentValidationActions.dispatchUpdateError(this.appStore, HttpInteraction.errorModel(error));
      })
      .doIt();
  }
}
